import {
  checkIsCriteriaFeedback,
  checkIsSectionFeedback,
  sectionFeedbackCorrectValueToDisplayValue
} from "../entities/recordingAssessmentFeedback.js";
import { parseGradingValue } from "./gradingAssessmentHelpers.js";
import { getNormalizedNodeGradingComparableValue } from "./normalizedNodeGradingHelpers.js";
function getAccuracyClassificationForGradingValue(gradingValueType, actual, expected, shouldTreatHigherScoresAsCorrect = false) {
  if (actual === void 0 || expected === void 0) {
    return void 0;
  }
  if (gradingValueType === "section") {
    return actual === expected ? "correct" : "incorrect";
  }
  const parsedActual = parseGradingValue(gradingValueType, actual);
  const parsedExpected = parseGradingValue(gradingValueType, expected);
  if (!parsedActual || !parsedExpected) {
    return void 0;
  }
  if (parsedActual.value === parsedExpected.value) {
    return "correct";
  }
  if (gradingValueType === "1_5_score") {
    const actualNumber = Number(parsedActual.value);
    const expectedNumber = Number(parsedExpected.value);
    if (shouldTreatHigherScoresAsCorrect) {
      if (actualNumber > expectedNumber) {
        return "correct";
      }
    }
    const difference = Math.abs(actualNumber - expectedNumber);
    if (difference === 1) {
      return "close";
    }
  }
  return "incorrect";
}
function evaluateFeedbackCorrectness(feedback, candidateValue) {
  if (checkIsSectionFeedback(feedback)) {
    const candidateDisplay = sectionFeedbackCorrectValueToDisplayValue(candidateValue);
    const correctDisplay = sectionFeedbackCorrectValueToDisplayValue(
      feedback.data.correct_value
    );
    const status = getAccuracyClassificationForGradingValue(
      "section",
      candidateDisplay,
      correctDisplay
    );
    return {
      isCorrect: status === "correct",
      isClose: status === "close"
    };
  }
  if (checkIsCriteriaFeedback(feedback)) {
    const status = getAccuracyClassificationForGradingValue(
      feedback.data.criteria_node.grading_value_type,
      candidateValue,
      feedback.data.correct_value
    );
    return {
      isCorrect: status === "correct",
      isClose: status === "close"
    };
  }
  return { isCorrect: false, isClose: false };
}
function calculateTestAccuracyWithResults(feedbackItems, results) {
  if (!feedbackItems || !results || results.length === 0) return null;
  let correct = 0;
  let close = 0;
  let incorrect = 0;
  results.forEach((r) => {
    const feedback = feedbackItems.find((f) => f.id === r.feedbackId);
    if (!feedback) return;
    const gradingValueType = checkIsSectionFeedback(feedback) ? "section" : feedback.data.criteria_node.grading_value_type;
    const comparableValue = r.testStatus === "error" ? void 0 : getNormalizedNodeGradingComparableValue({
      gradingValueType,
      grading: {
        status: r.testStatus,
        value: r.testValue
      }
    });
    const { isCorrect, isClose } = evaluateFeedbackCorrectness(
      feedback,
      comparableValue
    );
    if (isCorrect) correct++;
    else if (isClose) close++;
    else incorrect++;
  });
  const total = correct + close + incorrect;
  const accuracy = total > 0 ? correct / total * 100 : 0;
  return { total, correct, close, incorrect, accuracy };
}
export {
  calculateTestAccuracyWithResults,
  evaluateFeedbackCorrectness,
  getAccuracyClassificationForGradingValue
};
//# sourceMappingURL=feedbackHelpers.js.map
